export default "__VITE_ASSET__ejy3x3sN__"